import React from "react";

import * as Middleware from "@middlewares/index";
import { prizesList } from "@pages/dashboard/components2.0/Prizes/Prizes";
import { ITariff } from "@pages/dashboard/components/Price";

interface IProps {
  item: ITariff;
  userTariff: any;
  callback: Function;
}

const TariffInfo: React.FC<IProps> = (data) => {
  const tariffPrizesList = prizesList.filter((item) =>
    item.tariffs.includes(data.item.type)
  );

  return (
    <div className="modal-wrap">
      <button
        className="modal__close"
        onClick={() => {
          Middleware.Ui.Modal.close();
        }}
      />
      <div className="modal modal-tariff">
        <div className="modal-tariff__content">
          <h2 className="modal-tariff__title">Тариф «{data.item.name}»</h2>
          <div className="modal-tariff__desc">
            <ul className="modal-tariff__features">
              {data.item.description.map((item: any, index: number) => {
                return (
                  <li className="modal-tariff__features-item" key={index}>
                    <div className="modal-tariff__features-text">
                      {item.text}
                    </div>
                    <div className="modal-tariff__features-desc">
                      {item.description}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        {tariffPrizesList.length > 0 && (
          <div className="modal-prizes">
            <h3 className="modal-prizes__title">Призовой фонд</h3>
            <div className="modal-prizes__list">
              {tariffPrizesList?.map((prize: any) => {
                return (
                  <div className="modal-prizes__item" key={prize.id}>
                    <div className="modal-prizes__item-time">
                      {prize.duration}
                    </div>
                    <h4 className="modal-prizes__item-title">{prize.country}</h4>
                    <div className="modal-prizes__item-hotels">
                      {prize.hotels?.map((hotel: any, index: number) => {
                        return (
                          <div className="modal-prizes__item-hotel" key={index}>
                            <h5>{hotel.name}</h5>
                            <p>{hotel.description}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <button
          className={`btn btn--red btn--medium modal-tariff__btn ${
            0 < data.userTariff && data.userTariff >= data.item.id
              ? "disabled"
              : ""
          }`}
          onClick={(event) => {
            if (0 < data.userTariff && data.userTariff >= data.item.id) {
              event.preventDefault();
            } else {
              Middleware.Payment.tariff(data.item.id);
              data.callback(1);
              window.scrollTo(0, 0);
              Middleware.Ui.Modal.close();
            }
          }}
        >
          Купить
        </button>
      </div>
    </div>
  );
};

export default TariffInfo;
